module.exports = __webpack_public_path__ + "static/media/comingsoon.2d42ac5d.jpg";